<template>
  <div v-if="visible">
    <div class="dim">
      <div class="modal" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
          <div class="modal-content" >
            <div class="modal-header">
              <h4 class="modal-title" id="myModalLabel">Tutor 검색하기</h4>

              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close()"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body">
              - 해당 강사의 소속(ITM/CTM)을 먼저 선택하신 후 강사명을 검색하십시오.<br>
              - 검색된 강사명 중 해당 강사명을 선택하신 후 [등록]버튼을 눌러주세요.
            </div>
            <div class="modal-body">
              <table class="table table-hover table-bordered">
                <tr>
                  <th><input v-model="pop.type" name="type" type="radio" value="I">ITM <input v-model="pop.type" name="type" type="radio" value="C">CTM</th>
                  <td><input v-model="pop.name" type="text" class="form-control" id="colFormLabel" @keyup.enter="getTutors()" placeholder="강사명을 입력해주세요"/></td>
                  <td class="txt-center">
                    <button @click="getTutors()" class="btn btn-primary">검색</button>
                  </td>
                </tr>
              </table>
            </div>
            <div class="modal-body" style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
              <table class="table table-hover text-center">
                <tr v-for="item in tutors" :key="item.idx">
                  <td style="width: 30%"><input type="radio" name="value" @change="pickTutor(item)"></td>
                  <td style="width: 70%">{{item.englishname}}</td>
                </tr>
              </table>
            </div>
            <div class="modal-body text-center">
              <button @click="selectTutors" class="btn btn-primary">등록</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'tutorModal',
  props: {
    visible: {
      type: Boolean,
      require: true,
      default: false
    },
    pickSeries: {}
  },

  data: () => ({
    tutors: [],
    seriesInput: {},
    pop:{
      type: 'I',
      name: '',
      value: '',
    },
    tutor:{

    }
  }),

  watch: {
    visible: function (newVal) {
      if (newVal === true) {
        this.visible = true;
        // this.doSearch();
      } else {
        this.visible = false;
      }
    }
  },
  mounted() {
  },

  methods: {
    close() {
      this.$emit("close", false);
    },

    getTutors: function () {
      if(this.pop.name !== null && this.pop.name !== ''){
        const params = {
          type: this.pop.type,
          name: this.pop.name
        }
        this.axios.get("/v1/api/admin/tutors", {
          params : this.getParams(params)
        })
        .then((res) => {
          this.tutors = res.data.result;
        });
      }else{
        alert("강사명을 입력해주세요.")
      }
    },

    pickTutor: function (tutor) {
      this.tutor = tutor
      this.tutor.type = this.pop.type
      console.log(this.tutor)
    },

    selectTutors: function () {
      console.log(this.tutor)
      this.$emit("pick", this.tutor);
      this.$emit("close", false);
    },
  }
}
</script>

<style scoped>
.dim {
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  box-sizing: border-box;
  z-index: 1000;
}

.modal {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/popTutorSearch.vue